import PropTypes from 'prop-types';

import React, { Component } from 'react';
import autobind from 'autobind-decorator';
// import {default as Video, Controls, Play, Mute, Seek, Fullscreen, Time, Overlay } from 'react-html5video';
// import 'react-html5video/src/assets/video.css';

export default class PDFCardDark extends Component {
  static propTypes = {
    cardId: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired
  };

  state = {
    fullScreen: false
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  @autobind
  toggleFullscreen() {
    this.setState({
      fullScreen: !this.state.fullScreen
    });
  }

  render() {
    return (
      <div
        style={this.state.fullScreen ? styles.containerFullScreen : styles.container}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <iframe id="iframe0" ref="iframe" style={styles.iframe} src={this.props.card.url}>
          Iframe is not supported
        </iframe>
      </div>
    );
  }
}

const styles = {
  container: {
    position: 'relative',
    height: '100%',
    marginBottom: '20px',
    marginTop: '40px'
  },
  containerFullScreen: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    height: '100%',
    width: '100%',
    zIndex: '1000',
    justifyContent: 'center',
    padding: '0px 0px 0px',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none'
  },
  fullScreenBtn: {
    height: '25px',
    width: '25px',
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: '5px',
    right: '5px',
    cursor: 'pointer'
  }
};
